import { INK_ART } from "@/lib/site";

export const FlashPackBonus = ({ testid = "flash-pack-bonus" }) => (
  <div data-testid={testid} className="group flex items-center gap-5 border border-line bg-ink p-4 transition-colors duration-300 hover:border-acid/60">
    <div className="relative h-24 w-[68px] shrink-0">
      <img src={INK_ART.packSheet} alt="" className="absolute inset-0 h-full w-full rotate-[8deg] object-cover opacity-70 shadow-lg transition-transform duration-500 group-hover:rotate-[14deg]" />
      <img src={INK_ART.packCover} alt="Copertina Flash Pack Vol. 01" className="absolute inset-0 h-full w-full -rotate-3 object-cover shadow-[0_12px_30px_-8px_rgba(0,0,0,0.9)] transition-transform duration-500 group-hover:-rotate-6" />
    </div>
    <div>
      <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-acid">In regalo per chi si iscrive</p>
      <p className="mt-1.5 font-display text-sm font-bold uppercase">Flash Pack Vol. 01</p>
      <p className="mt-1 text-sm leading-snug text-bone/60">6 flash tattoo esclusivi in PDF, pronti da stampare e ricalcare. Lo scarichi subito e lo ricevi anche via email.</p>
    </div>
  </div>
);
